import * as Widgets from '@mm/constants/widgets';
import { NavigateConfig } from '@mm/state/model/WidgetModel';
import WidgetEntity from '../WidgetEntity';

class NavigateRequestModel extends WidgetEntity {
  static make({
    pageId,
    sortOrder,
    associatedPageId = null,
    oppositePageId = null,
    sendNextAfterValue,
    sendNextAfterMeasure,
    subtype = Widgets.NAVIGATE,
  }: {
    pageId: number;
    sortOrder: number;
    associatedPageId?: number | null;
    oppositePageId?: number | null;
    sendNextAfterValue?: NavigateConfig['sendNextAfterValue'];
    sendNextAfterMeasure?: NavigateConfig['sendNextAfterMeasure'];
    subtype?: typeof Widgets.NAVIGATE | 'unicorn_detector';
  }) {
    return {
      ...super.make(pageId, subtype, 'Untitled navigate', sortOrder),
      config: {
        pageId: associatedPageId,
        oppositePageId,
        sendNextAfterValue,
        sendNextAfterMeasure,
      },
    };
  }
}

export default NavigateRequestModel;
